'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTimeago = require('react-timeago');

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _buildFormatter = require('react-timeago/lib/formatters/buildFormatter');

var _buildFormatter2 = _interopRequireDefault(_buildFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STRINGS = {
  day: '1d',
  days: '%dd',
  hour: '1h',
  hours: '%dh',
  minute: '1m',
  minutes: '%dm',
  month: '1mo',
  months: '%dmo',
  prefixAgo: null,
  prefixFromNow: null,
  seconds: '1m',
  suffixAgo: 'ago',
  suffixFromNow: '',
  wordSeparator: ' ',
  year: '1yr',
  years: '%dyr'
};

var TimeAgo = function TimeAgo(props) {
  var formatter = (0, _buildFormatter2.default)(STRINGS);
  return _react2.default.createElement(_reactTimeago2.default, {
    date: props.date,
    formatter: formatter,
    live: false
  });
};

TimeAgo.propTypes = {
  date: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string]).isRequired
};

exports.default = TimeAgo;